// extracted by mini-css-extract-plugin
export var wrapButtons = "typeRoof-module--wrapButtons--RFzbX";
export var active = "typeRoof-module--active--SxwI2";
export var button = "typeRoof-module--button--c0S0a";
export var article = "typeRoof-module--article--xlWgf";
export var img = "typeRoof-module--img--KZ2j3";
export var figcaption = "typeRoof-module--figcaption--pK7w6";